<template>
  <div class="main" :style="{ width: width }">
    <div class="data-table">
      <div class="top-container" v-if="!hideHeader">
        <div
          v-for="(header, i) in headers"
          :key="i"
          :style="{ width: header.width }"
          :class="itemDetailComponent ? 'lineItemsHeaders' : 'test'"
        >
          <div
            :class="
              hideVerticalLine || i === headers.length - 1
                ? 'no-border-right'
                : 'border-right'
            "
            class="header-container left-align"
            :style="[
              { 'font-size': header.size ? header.size : '' },
              headerCustomStyle,
            ]"
          >
            {{ header.name }}
            <div v-if="header.infoIconReq">
              <BaseIcon
                name="info"
                class="header-info-btn"
                width="0.938rem"
                height="0.938rem"
                v-tooltip:bottom="header.tooltipInfo"
              />
            </div>
            <div
              :style="{ display: header.sortable ? 'flex' : 'none' }"
              :class="
                header.key != sortByKey
                  ? 'sort-buttons'
                  : 'sort-buttons-visible'
              "
            >
              <i
                @click="
                  sortByKey = header.key;
                  order = 'ASC';
                  clickSort(header.key, 'ASC');
                "
                :class="
                  header.key === sortByKey && order === 'ASC'
                    ? `selected-sort`
                    : `unselected-sort`
                "
                class="up"
                :id="`sort-${header.key}-asc`"
              >
                <BaseIcon name="arrowUpSort" width="1rem" height="1rem" />
              </i>
              <i
                @click="
                  sortByKey = header.key;
                  order = 'DES';
                  clickSort(header.key, 'DES');
                "
                :class="
                  header.key === sortByKey && order === 'DES'
                    ? `selected-sort`
                    : `unselected-sort`
                "
                class="down"
                :id="`sort-${header.key}-des`"
              >
                <BaseIcon name="arrowDownSort" width="1rem" height="1rem" />
              </i>
            </div>
          </div>
        </div>
      </div>
      <div class="data-container" :style="{ height: height }">
        <Loading v-if="loading" />
        <div class="data-container" :style="{ height: height }" v-else>
          <div v-if="items.length === 0 && !loading" class="parent-no-data">
            <NoData :message="$t('noData')"></NoData>
          </div>

          <div v-if="items.length > 0 && !loading" class="dummy-top-parent">
            <div
              v-for="(header, i) in headers"
              :key="i"
              :style="{ width: header.width }"
              class="dummy-top"
              :class="
                hideVerticalLine || i === headers.length - 1
                  ? 'no-border-right'
                  : 'border-right'
              "
            ></div>
          </div>
          <div v-for="(item, i) in items" :key="i" class="table-row">
            <div class="main-row">
              <div
                v-for="(header, j) in headers"
                :key="i + ' ' + j"
                :style="{
                  width: header.width,
                  background: i % 2 === 0 ? highlightColor : 'rgb(30,32,33)',
                }"
                class="table-td"
                :class="[
                  hideVerticalLine || j === headers.length - 1
                    ? 'no-border-right'
                    : 'border-right',
                  item.infoProps ? 'infoItem' : '',
                  item.customClass,
                ]"
              >
                <div
                  class="indicator-body"
                  v-if="getTpyTableValue(item, header.rootKey).isApdex"
                >
                  <div
                    :class="getTpyTableValue(item, header.rootKey).apdexColor"
                  >
                    <div class="indicate"></div>
                  </div>
                </div>
                <div
                  v-if="header.icon"
                  :id="`catch-event-${i}-${j}`"
                  class="icon-cell"
                >
                  <div class="conditional-div" v-if="header.secondaryIcon">
                    <span :class="header.secIconColor ? 'white' : 'yellow'">
                      <BaseIcon
                        v-if="checkCondition(item)"
                        :name="header.cellIcon"
                        height="1.2rem"
                        width="1.2rem"
                        v-tooltip:top="{
                          content: iconTooltipDataConditional,
                          disabled:
                            iconTooltipDataConditional == null ||
                            iconTooltipDataConditional.length == 0,
                        }"
                      ></BaseIcon>
                    </span>
                  </div>
                  <span @click="catchEvent(header.event, item)">
                    <BaseIcon
                      :name="header.icon"
                      class="ptr-cursor"
                      height="1.2rem"
                      width="1.2rem"
                      v-tooltip:top="{
                        content: iconTooltipData,
                        disabled:
                          iconTooltipData == null ||
                          iconTooltipData.length == 0,
                      }"
                    ></BaseIcon>
                  </span>
                  <span class="cls-col-txt">
                    {{ item[header.key] }}
                  </span>
                </div>
                <div
                  v-else-if="header.tdIconEnable && item.typeIcon.name"
                  @click="catchEvent(header.event, item)"
                >
                  <BaseIcon
                    :name="item.typeIcon.name"
                    width="1em"
                    height="1.5em"
                    :iconColor="item.typeIcon.style.color"
                  ></BaseIcon>
                </div>
                <div
                  v-else-if="header.type === 'cellWithAction'"
                  class="cell-action-container"
                >
                  <div class="cell-with-action">
                    <div
                      :class="isActiveInstances && 'cell-with-active-instances'"
                    >
                      <span v-if="isActiveInstances">
                        <span
                          :class="item.isActive ? header.customClass : ''"
                        ></span>
                      </span>
                      <span
                        :class="
                          item.isActive
                            ? 'active-instance-id'
                            : 'cursor-pointer'
                        "
                        @click="redirectTo(item, j)"
                      >
                        {{ item[header.key] }}
                      </span>
                    </div>
                    <div class="cell-with-infra-icon">
                      <div class="infrastructure" v-if="isApmInfraCorrelation">
                        <div v-if="item.isCorrelationAvailable">
                          <span
                            class="cursor-pointer"
                            @click="
                              redirectTo(item, j, item.isCorrelationAvailable)
                            "
                          >
                            <BaseIcon
                              name="infrastructure"
                              width="2.2rem"
                              height="1.6rem"
                            />
                          </span>
                        </div>
                        <div v-else>
                          <BaseIcon
                            name="infrastructureDisable"
                            width="2.2rem"
                            height="1.6rem"
                            v-tooltip:top="$t('correlationNotAvailable')"
                          />
                        </div>
                      </div>
                      <span
                        v-if="getIsUserAdmin"
                        @click="catchEvent(header.event, item)"
                      >
                        <BaseIcon
                          :name="header.cellIcon"
                          class="ptr-cursor cur-pos"
                          height="1.4rem"
                          width="1.4rem"
                          v-tooltip:top="{
                            content: iconTooltipData,
                            disabled:
                              iconTooltipData == null ||
                              iconTooltipData.length == 0,
                          }"
                        ></BaseIcon>
                      </span>
                    </div>
                  </div>
                </div>
                <div v-else-if="header.key === 'infrastructure'">
                  <div v-if="item[header.key]">
                    <BaseIcon
                      name="infrastructure"
                      width="2.2rem"
                      height="1.6rem"
                      @click="openTopologyRightSideBox(item)"
                      style="cursor: pointer"
                    />
                  </div>
                  <div v-else>-</div>
                </div>
                <div
                  v-else-if="header.type === 'cellWithActionConditional'"
                  class="cell-action-container"
                >
                  <div class="cell-with-action">
                    <span
                      class="cls-col-txt cursor-pointer"
                      @click="redirectTo(item, j)"
                    >
                      {{ item[header.key] }}
                    </span>
                    <span @click="catchEvent(header.event, item)">
                      <BaseIcon
                        v-if="checkCondition(item)"
                        :name="header.cellIcon"
                        class="ptr-cursor cur-pos"
                        height="1.2rem"
                        width="1.2rem"
                        v-tooltip:top="{
                          content: iconTooltipData,
                          disabled:
                            iconTooltipData == null ||
                            iconTooltipData.length == 0,
                        }"
                      ></BaseIcon>
                    </span>
                  </div>
                </div>

                <div
                  v-else-if="header.type === 'renderDynamicComponent'"
                  class="dynamic-comp-container"
                >
                  <component
                    :is="header.formatComponent"
                    :row="item"
                    :header="header"
                  ></component>
                </div>

                <div
                  v-else-if="
                    redirectable &&
                    header.key != 'modified' &&
                    header.key != 'startTime'
                  "
                  @click="redirectTo(item, j)"
                  :class="` ${
                    !header.isEllipsisReq ? 'redirect' : 'ellipsis-redirect'
                  }`"
                  :id="`redirect-${i}-${j}`"
                  :style="{
                    cursor:
                      header.routable === false
                        ? cursorType.auto
                        : cursorType.pointer,
                    width: header.type === 'actions' ? 'fit-content' : '100%',
                    display: header?.showIcon && 'flex',
                    alignItems: header?.showIcon && 'center',
                  }"
                >
                  <!-- Uncomment below to insert component as column value. Also add v-else in next span -->
                  <!-- <span
                    v-if="typeof getValue(header, item) === 'object'"
                    :class="`td-span ${tdSpanClass}`"
                  >
                    <component
                      :is="getValue(header, item).component"
                      v-bind="getValue(header, item).props"
                    ></component>
                  </span> -->
                  <span
                    v-html="getValue(header, item)"
                    :class="`td-span ${tdSpanClass} ${item.customClass || ''} ${
                      header.enableEllipsis ? 'ellipsis ellipsis-redirect' : ''
                    }`"
                    v-tooltip:bottom="{
                      content: getValueToolTipText(header, item),
                      disabled: !header.enableEllipsis,
                      handleResize: true,
                    }"
                    :style="{
                      'max-width':
                        (getValueToolTipText(header, item) + '').length <
                        header.width.split('%')[0]
                          ? `${
                              (getValueToolTipText(header, item) + '').length /
                              1.2
                            }rem !important`
                          : '95% !important',
                    }"
                  >
                  </span>
                  <BaseIcon
                    v-if="header.key === item.name"
                    class="showIcon"
                    :name="item.icon"
                    width="1rem"
                    height="1rem"
                  />
                  <!-- {{ getValue(header, item) }} -->
                </div>
                <div
                  v-else-if="
                    header.key === 'startTime' || header.key === 'timestamp'
                  "
                >
                  {{
                    $filters.dateformat(
                      parseInt(item[header.key]),
                      timezoneoffset,
                      dateTime,
                    )
                  }}
                </div>
                <div v-else-if="header.key === 'modified'">
                  {{ item['modified'] }} {{ ', ' }}
                  {{
                    $filters.dateformat(
                      parseInt(item['lastUpdate']),
                      timezoneoffset,
                      dateTime,
                    )
                  }}
                </div>
                <div v-else>
                  <b>
                    <span v-html="item[header.key]" class="td-span"> </span>
                  </b>
                </div>
                <div v-if="header.type === 'actions'" class="actions">
                  <div v-for="(action, k) in actions" :key="`action-${k}`">
                    <button
                      v-if="action.columnIndex ? j == action.columnIndex : true"
                      :class="{
                        'action-btn': true,
                        'action-btn-nestedItem': action.icon === 'toggleButton',
                        disabled: hasDisableAction(item, action),
                      }"
                      :disabled="hasDisableAction(item, action)"
                    >
                      <span
                        v-if="
                          action.icon === 'toggleButton'
                            ? hasWritePermission
                            : true
                        "
                        @click="actionClick(item, action.type, i)"
                      >
                        <BaseIcon
                          :name="
                            item.showDetails ? action.toggleIcon : action.icon
                          "
                          height="1.2em"
                          :width="action.showText ? '2em' : '1.2em'"
                          v-tooltip:top="{
                            content: action.toolTip?.content || '',
                            disabled: !action.toolTip?.content,
                          }"
                        />
                      </span>
                      <span
                        v-if="action.showText"
                        style="
                          color: rgb(245, 150, 0);
                          padding-left: 0.3rem;
                          cursor: default !important;
                        "
                      >
                        {{ action.showText }}
                      </span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <!-- To do -->
            <div
              v-if="item['showDetails']"
              :class="`table-td expanded ${item.customClass || ''}`"
            >
              <component
                :is="itemDetailComponent"
                v-bind="item['infoProps']"
              ></component>
              <!-- <AlertInfo /> -->
            </div>
          </div>
          <!-- Dummy row is used to extend border to cover table height -->
          <div
            v-if="items.length > 0 && !loading && !isAddRowReq"
            class="dummy-parent"
          >
            <div
              v-for="(header, i) in headers"
              :key="i"
              :style="{ width: header.width }"
              class="dummy"
              :class="
                hideVerticalLine || i === headers.length - 1
                  ? 'no-border-right'
                  : 'border-right'
              "
            ></div>
          </div>
          <div class="add-row-box" v-if="isAddRowReq">
            <RexButton
              variant="secondary"
              class="add-row-btn"
              @onClick="() => $emit('addRow')"
              :styling="{ width: 'fit-content' }"
              id="rex-table-add-row-btn"
            >
              {{ addRowText }}
            </RexButton>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations, mapGetters } from 'vuex';
import { dateTime } from '@/utils/time/dateconstants';
import NoData from '@/rex-components/rex-no-data.vue';
import Loading from '@/rex-components/rex-loading.vue';
import { DataTypes } from '@/utils/enums/dataTypes';
import { formatDate } from '@/utils/time/formatDate';
import AlertInfo from '@/components/AlertsV2/AlertInfo.vue';
import RexButton from '@/rex-components/rex-button.vue';
import { getTpyTableValue } from '@/utils/helper-function';
import { notificationError } from '@/utils/notification';
import i18n from '@/plugins/i18n';

export default {
  components: { NoData, Loading, AlertInfo, RexButton },
  props: {
    /**
     *
     *The columns for the table with information about the widths of the columns, sortable, default sort and order
     * @example
      headers: [
        {
          key: name,
          name: this.$t('name'),
          width: '36%',
          sortable: false,
          size: '1.0rem'
        },
        {
          key: alerts,
          name: this.$t('alerts'),
          width: '14%',
          sortable: true,
          dataType: 'float',
          defaultOrder: DES,
          defaultSortBy: true
        },
        ]
     *
     */
    headers: { type: Array, required: true },
    /**
     *
     *Data of the table to be displayed
     *
     */
    items: { type: Array, required: true },
    /**
     *
     *If the table has search function
     *
     */
    redirectable: { type: Boolean, default: true },
    /**
     *
     *If table has actions on row elements
     *
     */
    actions: { type: Array },
    /**
     *
     *The accent color of the table on entries
     *
     */
    highlight: { type: String, default: 'primary' },
    /**
     *
     *Height of the table
     *
     */
    height: { type: String, required: true },
    /**
     *
     *Width of the table as percentage of the page
     *
     */
    width: { type: String, required: true },
    /**
     *
     *For component level loading
     *
     */
    loading: { type: Boolean },

    /**
     *
     * Vertical line should be hidden or not
     *
     */
    hideVerticalLine: { type: Boolean, default: false },

    /**
     *
     * Apm Infra correlation check
     *
     */
    isApmInfraCorrelation: { type: Boolean, default: false },

    /**
     *
     * Instance Active Check
     *
     */
    isActiveInstances: { type: Boolean, default: false },

    /**
     *
     * Pass styles object to modify the headers accordingly
     *
     */
    headerCustomStyle: { type: Object, default: () => {} },

    /**
     *
     * Pass the tooltip content here,
     * if nothing is passed it will disable the tooltip
     *
     */
    iconTooltipData: { type: String, default: '' },
    /** * * Pass the tooltip for coditional content here, * if nothing is passed it will disable
the tooltip * */
    iconTooltipDataConditional: {
      type: String,
      default: '',
    },
    /**
     *
     * Pass this variable to enable add row button
     *
     */
    isAddRowReq: {
      type: Boolean,
      default: false,
    },
    /**
     *
     * Add row button text
     *
     */
    addRowText: {
      type: String,
      default: '',
    },

    /**
     *
     * Pass the name of the class for td elements styling
     *
     */
    tdSpanClass: { type: String, default: '' },
    /** * * Pass the name of the condition to render icon for cellWithActionConditional header type * */
    condition: {
      type: String,
      default: '',
    },
    itemDetailComponent: {
      type: Object,
      default: null,
    },
    /**
     *
     * Table header wont be displayed on receiving true
     *
     */
    hideHeader: {
      type: Boolean,
      default: false,
    },
    /**
     *
     * If the table has RBAC V2 write permission
     *
     */
    hasWritePermission: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dateTime,
      curr: '',
      sortByKey: '',
      order: '',
      dataType: '',
      showSearch: false,
      cursorType: {
        pointer: 'pointer',
        auto: 'auto',
      },
    };
  },
  computed: {
    ...mapState('globalState/settings', ['timezoneoffset']),
    ...mapGetters('globalState/user', ['getIsUserAdmin']),
    filteredItems() {
      return this.filter();
    },
    isAnyFilterSelected() {
      return this.isFilterSelected();
    },
    highlightColor() {
      return this.highlight === 'primary' ? 'rgb(41,44,50)' : 'rgb(41,44,50)';
    },
  },
  methods: {
    ...mapMutations('apmState/topology', ['setTopoInfraRightState', 'setNode']),
    getTpyTableValue,
    redirectTo(option, columnID, isCorrelationAvailable) {
      if (isCorrelationAvailable) {
        this.$router.push({
          name: 'infraDetails',
          query: {
            apmInfraId: option.correlatedInstanceId,
            correlatedServiceId: option.correlatedServiceId,
          },
        });
      } else {
        this.$emit('redirectInput', option, this.headers[columnID].key);
      }
    },

    clickSort(col, order) {
      let item = { header: col, order: order };
      this.$emit('updateSort', item);
    },
    actionClick(item, type, ind) {
      let actionItem = { item: item, type: type, ind };
      this.$emit('tableAction', actionItem);
    },
    catchEvent(eventName, item) {
      this.$emit(eventName, item);
    },
    getValueToolTipText(header, item) {
      if (header.dataType === DataTypes.TIME) {
        return formatDate(item[header.key], this.timezoneoffset);
      } else if (header.customToolTipTextStyle) {
        return (
          '<span style="' +
          this.styleConverter(header.customToolTipTextStyle) +
          '">' +
          item[header.key] +
          '</span>'
        );
      } else return getTpyTableValue(item, header.key);
    },
    getValue(header, item) {
      if (header.dataType === DataTypes.TIME) {
        return formatDate(item[header.key], this.timezoneoffset);
      } else if (header.customTextStyle) {
        return (
          '<span style="' +
          this.styleConverter(header.customTextStyle) +
          '">' +
          item[header.key] +
          '</span>'
        );
      } else
        return header.aggregationNum
          ? getTpyTableValue(item, header.key) / header.aggregationNum
          : getTpyTableValue(item, header.key);
    },
    styleConverter(style) {
      return Object.entries(style)
        .reduce((acc, [key, value]) => {
          const convertedKey = key.replace(/[A-Z]/g, (match) => {
            return `-${match.toLowerCase()}`;
          });

          acc.push(`${convertedKey}: ${value}`);

          return acc;
        }, [])
        .join('; ');
    },
    checkCondition(item) {
      const prop = this.condition;
      if (item[prop]) return true;
      else return false;
    },
    intiDefaultSort() {
      for (let i in this.headers) {
        let header = this.headers[i];
        if (header.defaultSortBy) {
          this.sortByKey = header.key;
          this.order = header.defaultOrder;
        }
      }
    },
    openTopologyRightSideBox(item) {
      if (item?.infrastructure?.permissions?.length > 0) {
        this.setNode(item.infrastructure);
        this.setTopoInfraRightState(true);
      } else {
        notificationError(i18n.global.t('permission-denied'));
      }
    },
    hasDisableAction(item, action) {
      if (
        (item.isCopy !== undefined &&
          !item.isCopy &&
          action.icon === 'copyStripes') ||
        (item.isDelete !== undefined &&
          !item.isDelete &&
          action.icon === 'deleteFilled') ||
        (item.isEdit !== undefined &&
          !item.isEdit &&
          action.icon === 'editFilled')
      )
        return true;
      return false;
    },
  },
  created() {
    this.intiDefaultSort();
  },
};
</script>
<style lang="scss" scoped>
.dummy {
  height: 100%;
  display: inline-flex;
  &:last-child {
    border-right: none;
  }
}
.dummy-top {
  height: 0.825rem;
  &:last-child {
    border-right: none;
  }
}
.dummy-top-parent {
  display: flex;
}
.dummy-parent {
  flex-grow: 1;
}
.table-row {
  // display: flex;
  background: $bg-secondary;
}
.table-td {
  display: inline;
  align-items: center;
  text-align: left;
  display: flex;
  align-items: center;
  overflow: hidden;
  //margin: 0.475rem 0rem 0.475rem 0rem;
  text-align: left;
  min-height: 3.75rem;
  height: auto;
  padding: {
    top: 0.3rem;
    bottom: 0.3rem;
    left: 1.8725rem;
  }
  .semibold {
    font-family: $bold;
  }
  .good {
    color: $good;
  }
  .poor {
    color: $poor;
  }
  .fair {
    color: $fair;
  }
  .primary {
    background-color: $highlight-primary;
  }
  .secondary {
    background-color: $highlight-secondary;
  }
  .colorHeading {
    color: $font-primary;
  }
}
.table-td:first-child {
  border-left: 0.825rem solid $bg-secondary;
  padding-left: 1.044rem;
}
.table-td:last-child {
  border-right: 0.825rem solid $bg-secondary;
}
.main {
  @include dropshadow-effect();
  border-radius: 1.0625rem;
}
.no-border-right {
  border-right: none;
}
.border-right {
  border-right: $border-primary 0.0125rem solid;
}
.data-table {
  border-bottom-left-radius: 1.0625rem;
  border-bottom-right-radius: 1.0625rem;
  //border: 0.0063rem $border-color-primary solid;
  border-radius: 1.0625rem;
}
.container-section {
  display: flex;
  flex-direction: row;
  .left-align {
    justify-content: flex-start;
  }
  .center-align {
    justify-content: center;
  }
}
.header-container {
  padding-left: 1.625rem;
}
.top-container:first-child > .header-container:first-child {
  padding-left: 1.625rem;
}
.top-container:first-child > .header-container {
  padding-left: 1.625rem;
}
.test {
  //border-right: $border-primary 0.0125rem solid;
}
.test:first-child > .header-container {
  border-top-left-radius: 0.7875rem;
  //padding-left: 1.8725rem;
}
.test > .header-container {
  padding-left: 1.8725rem;
}
.test:last-child > .header-container {
  border-top-right-radius: 0.7875rem;
  border-right: 0px;
}
.left-align {
  justify-content: flex-start;
  padding-left: 0.625rem;
  text-align: left;
}
.center-align {
  justify-content: center;
}
.top-container {
  position: relative;
  display: flex;
}
.cur-pos {
  position: relative;
  right: 1rem;
}
.header-container {
  position: relative;
  display: flex;
  align-items: center;
  border-bottom: 0.0125rem solid $border-color-primary;
  color: $font-primary;
  font-family: $semi-bold;
  font-size: 1.25rem;
  height: 3.5rem;
  background-color: $bg-tertiary;
}
.sort-buttons-visible {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  position: relative;
  cursor: pointer;
}
.sort-buttons {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  position: relative;
  cursor: pointer;
  visibility: hidden;
}
.selected-sort {
  z-index: 1;
  fill: $color-brand-accent;
}
.unselected-sort {
  fill: $color-brand-accent-inactive;
  z-index: 2;
}
.up {
  margin-left: 0.5rem;
}
.down {
  margin-right: 0.5rem;
}
.container-section {
  height: 100%;
}
.content-full {
  border-right: $border-primary 0.2px solid;
  height: 100%;
}
.container-section:first-child > .content-full {
  padding-left: 1rem;
}
.container-section:first-child > .content-full > {
  padding-left: 1rem;
}
.container-section:last-child > .content-full {
  padding-right: 1rem;
}
.content-container {
  //border-right: $border-primary 0.2px solid;
}
.container-section:first-child
  > .content-full
  > .content-container
  > .content-row {
  padding-left: 1.625rem;
}
.container-section:last-child > .content-full > .content-container:last-child {
  border-right: none;
}
.data-container {
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
  background: $bg-secondary;
  border-bottom-left-radius: 0.688rem;
  border-bottom-right-radius: 0.688rem;
  .content-container {
    //border-right: $border-primary 0.2px solid;
    .content-row {
      display: flex;
      align-items: center;
      overflow: hidden;
      margin: 0.475rem 0rem 0.475rem 0rem;
      text-align: left;
      &:first-child {
        margin-top: 1rem;
      }
      padding: {
        top: 0.3rem;
        bottom: 0.3rem;
        left: 2.325rem;
      }
      .semibold {
        font-family: $bold;
      }
      .good {
        color: $good;
      }
      .poor {
        color: $poor;
      }
      .fair {
        color: $fair;
      }
      .primary {
        background-color: $highlight-primary;
      }
      .secondary {
        background-color: $highlight-secondary;
      }
      .colorHeading {
        color: $font-primary;
      }
    }
  }
}
//removing the scroll width for the table overflow
//for chrome and safari
.data-container::-webkit-scrollbar {
  width: 0 !important;
}
//for edge and firefox
.data-container {
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.search-btn {
  margin: 0px 0.625rem;
  @include svg-fill-pointer($font-primary);
}
.search-input {
  position: absolute;
  display: flex;
  height: 2.25rem;
  width: 17rem;
  border-radius: 0.1875rem;
  border: 0.0625rem $color-brand-accent solid;
  background-color: $bg-primary;
  z-index: 4;
  margin-left: 1.25rem;
  margin-top: 0.25rem;
  padding: 0.3rem 0rem;
  input {
    border: none;
    caret-color: $color-brand-accent;
    color: $font-primary;
  }
  textarea:focus,
  input:focus {
    outline: none;
  }
}
.redirect {
  cursor: pointer;
}
.pagination {
  height: 3.75rem;
  display: flex;
  justify-content: flex-end;
}
.action-btn {
  @include btn-reset;
  fill: $color-brand-accent;
}

.actions {
  display: flex;
  flex-direction: row;
  gap: 1.5rem;
  flex-wrap: wrap;
}
.action-btn-nestedItem {
  margin: 0rem !important;
}
.header-container:hover > .sort-buttons {
  visibility: visible;
}
.content-row:first-child {
  padding-top: 0.625rem;
}
.row-icon {
  margin-right: 1rem;
  cursor: pointer;
}
.td-span {
  word-break: break-word;
}
.cls-col-txt {
  padding-left: 1.25rem;
}
.cursor-pointer {
  display: flex;
  margin-left: 1.3rem;
}

.active-instance-id {
  color: $good;
  display: flex;
}

.active-instance-id:hover {
  cursor: pointer;
}

.cursor-pointer:hover {
  cursor: pointer;
}

.parent-no-data {
  height: 100%;
}
.sm-font-size {
  font-size: 0.875rem;
}
.ellipsis-redirect {
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 9.688rem;
}
.cell-with-action {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.cell-with-active-instances {
  width: 75%;
  display: flex;
  justify-content: flex-start;
}
.cell-action-container {
  width: 100%;
}
.yellow {
  fill: $color-brand-accent;
}
.white {
  fill: $color-white;
}
.conditional-div {
  display: inline-block;
  width: 30%;
}
.icon-cell {
  width: 100%;
}
.dynamic-comp-container {
  width: 100%;
  height: 100%;
}
.main-row {
  display: flex;
}
.expanded {
  // border-top: 1px solid black;
  background: rgb(41, 44, 50);
  padding-bottom: 8px;
  margin-top: -4px;
  margin-bottom: 6px;
  border-right: 0.825rem solid #1e2021;
  border-left: 0.62rem solid $color-brand-accent;
  margin-left: 9.8px;
  height: 7rem;
}
.expanded.inactive {
  border-left: 0.62rem solid rgb(132, 132, 132) !important;
  opacity: 1 !important;
}
.inactive {
  opacity: 0.6 !important;
}
.infoItem {
  background: rgb(41, 44, 50) !important;
  margin-bottom: 6px;
  opacity: 1 !important;
}
.infoItem:first-child {
  border-left: 0.62rem solid $color-brand-accent;
  margin-left: 9.8px;
}
.infoItem.inactive:first-child {
  border-left: 0.62rem solid rgb(132, 132, 132) !important;
}
.header-info-btn {
  margin-left: 0.5rem;
  @include svg-fill-pointer($color-brand-accent);
}
.add-row-box {
  display: flex;
  justify-content: center;
  align-items: center;
}
.add-row-btn {
  background-color: inherit;
  box-shadow: none;
  color: $color-brand-accent;
  border: none;
}
.ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: default !important;
  max-width: 22em !important;
  // min-width: 12em !important;
  display: block !important;
}
.lineItemsHeaders > .header-container {
  padding-left: 2.2rem;
}
.good {
  display: flex;
  margin-right: 0.5rem;
  justify-content: center;
  // margin-left: 3em;
  color: $good;
  .indicate {
    align-items: center;
    height: 0.5em;
    width: 0.5em;
    border-radius: 50%;
    background: $good;
  }
}
.fair {
  display: flex;
  margin-right: 0.5rem;
  justify-content: center;
  // margin-left: 3em;
  color: $fair;
  .indicate {
    align-items: center;
    height: 0.5em;
    width: 0.5em;
    border-radius: 50%;
    background: $fair;
  }
}
.poor {
  display: flex;
  margin-right: 0.5rem;
  justify-content: center;
  // margin-left: 3em;
  color: $poor;
  .indicate {
    align-items: center;
    height: 0.5em;
    width: 0.5em;
    border-radius: 50%;
    background: $poor;
  }
}
.blue {
  display: flex;
  margin-right: 0.5rem;
  justify-content: center;
  // margin-left: 3em;
  color: $blue-topo;
  .indicate {
    align-items: center;
    height: 0.5em;
    width: 0.5em;
    border-radius: 50%;
    background: $blue-topo;
  }
}

.infra {
  display: flex;
  margin-right: 0.5rem;
  justify-content: center;
  // margin-left: 3em;
  color: $blue-topo;
  .indicate {
    align-items: center;
    height: 0.5em;
    width: 0.5em;
    border-radius: 50%;
    background: #d6c2f9;
  }
}
.non-real {
  display: flex;
  margin-right: 0.5rem;
  justify-content: center;
  // margin-left: 3em;
  color: $blue-topo;
  .indicate {
    align-items: center;
    height: 0.5em;
    width: 0.5em;
    border-radius: 50%;
    background: #595959;
  }
}
.cell-with-infra-icon {
  width: 25%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
}
.infrastructure {
  margin-top: 0.16em;
  margin-right: 1.5em;
}
.showIcon {
  margin-left: 0.25em;
  @include svg-fill($color-active-blue);
  vertical-align: super;
  margin-bottom: 1em;
}
</style>
